import React from "react";
import Seo from "@/components/site/Seo";
import { CONTACT, BRAND } from "@/data/site";

export function Privacy() {
  return (
    <>
      <Seo
        title="Privacy Policy | Golden Touch Lash & Brow"
        description="How Golden Touch Lash & Brow collects, uses and protects your information."
        path="/privacy"
        noindex
      />
      <Legal title="Privacy Policy">
        <p>
          {BRAND.name} respects your privacy. This policy explains what information we collect and
          how we use it.
        </p>
        <h2>Information We Collect</h2>
        <p>
          When you book an appointment or contact us, you may provide your name, phone number, email
          and appointment details. Booking is handled through our scheduling provider (Acuity /
          Squarespace Scheduling), which processes your information to manage your appointment.
        </p>
        <h2>How We Use Your Information</h2>
        <p>
          We use your information solely to schedule, confirm and manage your appointments and to
          communicate with you about your visit. We do not sell your personal information.
        </p>
        <h2>Contact</h2>
        <p>
          Questions about this policy? Call or text us at{" "}
          <a href={CONTACT.phoneHref} className="text-gold hover:underline">
            {CONTACT.phoneDisplay}
          </a>
          .
        </p>
      </Legal>
    </>
  );
}

export function Terms() {
  return (
    <>
      <Seo
        title="Terms of Service | Golden Touch Lash & Brow"
        description="Terms of service for Golden Touch Lash & Brow."
        path="/terms"
        noindex
      />
      <Legal title="Terms of Service">
        <p>
          By booking an appointment with {BRAND.name}, you agree to the following terms.
        </p>
        <h2>Appointments</h2>
        <p>
          Appointments are scheduled through our online booking system. Please arrive on time and
          follow any preparation guidance provided for your service.
        </p>
        <h2>Cancellations</h2>
        <p>
          If you need to cancel or reschedule, please do so as early as possible using your booking
          confirmation, or by calling or texting us.
        </p>
        <h2>Contact</h2>
        <p>
          For any questions, reach us at{" "}
          <a href={CONTACT.phoneHref} className="text-gold hover:underline">
            {CONTACT.phoneDisplay}
          </a>
          .
        </p>
      </Legal>
    </>
  );
}

function Legal({ title, children }) {
  return (
    <section className="bg-onyx pt-28 md:pt-36 pb-20">
      <div className="mx-auto max-w-3xl px-6 lg:px-10">
        <h1 className="font-display text-4xl md:text-5xl text-ivory">{title}</h1>
        <div className="prose-legal mt-8 space-y-5 text-muted-ivory leading-relaxed [&>h2]:font-display [&>h2]:text-xl [&>h2]:text-ivory [&>h2]:mt-8">
          {children}
        </div>
      </div>
    </section>
  );
}
